/**
 * Checks whether an AccountMarketingMaterial has all print assets.
 *
 * @param {Object} accountMarketingMaterial The AccountMarketingMaterial.
 * @returns {*}
 */
export const accountMarketingMaterialHasAssets = accountMarketingMaterial => {
  return (
    accountMarketingMaterial?.pdf_url && accountMarketingMaterial?.image_url
  );
};
